export const blocks = [
  {
    bg: require('@/assets/images/bg-2.jpg'),
    icon: require('@/assets/images/icon-1.svg'),
    text: 'Servicios de Importación y Exportación',
    hash: '#import-and-export'
  }, {
    bg: require('@/assets/images/bg-3.jpg'),
    icon: require('@/assets/images/icon-0.svg'),
    text: 'Servicios de Agencia Naviera',
    hash: '#shipping-agency'
  }, {
    bg: require('@/assets/images/bg-1.jpg'),
    icon: require('@/assets/images/icon-2.svg'),
    text: 'Servicios de Brokerage',
    hash: '#brokerage'
  }
]

export const strategies = [
  'Ofrecer los más competitivos servicios de Aduana, así como asesorías técnicas, legales y tributarias.',
  'Utilizar las tecnologías más avanzadas para estar siempre conectado con el cliente, en el lugar y al tiempo apropiado.',
  'Manejo logístico del transporte interno, así como el seguimiento de la carga marítima y aérea.',
  'Facilitar a la empresa el acceso a un entrenamiento y capacitación del personal responsable en el área.',
  'Disposición de un servicio integral para las operaciones aduaneras. (Importación, Exportación y Tránsito).'
]
